import React, { useEffect, useRef } from 'react';
type ProductVideoProps = {
  src: string;
  label: string;
  className?: string;
};

/**
 * Always-silent looping product video. Audio is forced off on mount and
 * re-forced if anything tries to unmute it (no controls are exposed).
 */
export function ProductVideo({
  src,
  label,
  className = ''
}: ProductVideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const forceSilent = () => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
  };
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    forceSilent();
    const attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(() => {
        // Autoplay blocked (e.g. low-power mode) — first frame stays visible.
      });
    }
  }, []);
  return <video ref={videoRef} src={src} aria-label={label} autoPlay loop muted playsInline preload="metadata" controls={false} disablePictureInPicture disableRemotePlayback onVolumeChange={forceSilent} onLoadedMetadata={forceSilent} className={className} data-id="element-367" data-mp="2r6hpu6sqnvss" />;
}